import { COUNTRY_CODE_IE, COUNTRY_CODE_UK } from '../constants/basicData';

import { useCookieString, isIrishUserCookieValue } from './cookies';

/**
 * Hook variant that participates in SSR — reads the cookie via React context
 * so the server-rendered HTML matches what the browser will produce on
 * hydrate. A visitor who hasn't been geo-tagged yet counts as UK, as the SSR
 * cache key does, so a page cached for a UK visitor hydrates for them too.
 */
export const useCountryCode = (): string => {
    const cookieValue = useCookieString('isIrishUser');
    return isIrishUserCookieValue(cookieValue) ? COUNTRY_CODE_IE : COUNTRY_CODE_UK;
};

/**
 * Pure helper for non-React code that already has a cookie value handy
 * (e.g. analytics handlers reading the raw `isIrishUser` cookie themselves).
 */
export const countryCodeFromCookie = (cookieValue: unknown): string => {
    if (!cookieValue) return '';
    return isIrishUserCookieValue(cookieValue) ? COUNTRY_CODE_IE : COUNTRY_CODE_UK;
};
